<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'START'"
                >
                  <v-text-field
                    slot="activator"
                    label="WayAssign Date"
                    type="text"
                    prepend-icon="event"
                    v-model="wayAssignDate"
                    readonly
                    :rules="rules.wayAssignDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="wayAssignDate" :rules="rules.wayAssignDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="wayAssign.wayId"
                  :items="wayList"
                  color="blue-grey lighten-2"
                  label="Choose Way..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="status != 'START'"
                  :rules="rules.wayRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="wayAssign.userId"
                  :items="marketerList"
                  color="blue-grey lighten-2"
                  label="Choose Marketer..."
                  item-text="username"
                  menu-props="auto"
                  item-value="id"
                  :readonly="status != 'START'"
                  :rules="rules.marketerRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id">
                <v-select
                  :items="wayAssignStatusList"
                  label="Choose WayAssign Status ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  v-model="wayAssign.status"
                  :disabled="status == 'START'"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id && status == 'COMPLETED'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  disabled
                >
                  <v-text-field
                    slot="activator"
                    label="Complete Date"
                    type="text"
                    prepend-icon="event"
                    v-model="completeDate"
                    readonly
                    :rules="rules.completeDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="completeDate" :rules="rules.completeDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="wayAssign.description"
                  type="text"
                  :readonly="status != 'START'"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="wayAssign.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="wayAssign.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="wayAssign.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="status =='COMPLETED'">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { wayAssignService } from "../../services/way-assign-service";
import { wayService } from "../../services/way-service";
import { userService } from "../../services/user-service";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { WayAssign } from "../../models/model";
import { WayAssignFormRules } from "../../helpers/validation-rules";

export default {
  name: "WayAssignDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Way Assign",
        disabled: false,
        to: "way-assigns"
      },
      {
        text: "Way Assign Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    status: "START",
    wayAssignDate: "",
    completeDate: "",
    wayAssign: new WayAssign(),
    oldwayAssign: new WayAssign(),
    rules: new WayAssignFormRules(),
    responseError: "",
    messageDialogBox: false,
    saveLoading: false,
    wayList: [],
    marketerList: [],
    btnDisabled: false,
    wayAssignStatusList: [
      { label: "START", value: "START" },
      { label: "PROGRESS", value: "PROGRESS" },
      { label: "COMPLETED", value: "COMPLETED" }
    ]
  }),

  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new way assign
      this.wayAssignDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.completeDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getWayAssignDetail(id);
    }
    this.getWayList();
    this.getMarketerList();
  },

  methods: {
    getWayList() {
      wayService
        .getWaysByStatus("ACTIVE")
        .then(res => {
          this.wayList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMarketerList() {
      userService
        .getUsersByRoleAndStatus("MARKETING", "ACTIVE")
        .then(res => {
          this.marketerList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.push("/way-assigns");
    },

    getWayAssignDetail(id) {
      wayAssignService
        .getWayAssignDetail(id)
        .then(res => {
          this.wayAssign = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.wayAssign.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.wayAssign.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.status = this.wayAssign.status;
          if (this.status == "COMPLETED") {
            this.btnDisabled = true;
          }
          if (this.status == "PROGRESS") {
            this.wayAssignStatusList = [
              { label: "PROGRESS", value: "PROGRESS" },
              { label: "COMPLETED", value: "COMPLETED" }
            ];
          }
          this.wayAssignDate = commonService.millisecondToDate(
            this.wayAssign.wayAssignDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.completeDate = commonService.millisecondToDate(
            this.wayAssign.completeDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldWayAssign = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        //convert to millisecond
        this.wayAssign.wayAssignDateInMilliSeconds = commonService.convertToMilliseconds(
          this.wayAssignDate
        );
        wayAssignService
          .saveWayAssign(this.wayAssign)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.wayAssign.id) {
        this.wayAssign = new WayAssign();
      } else {
        this.wayAssign = Object.assign({}, this.oldWayAssign);
      }
    }
  }
};
</script>

